import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Desktop,
  Tablet,
  Mobile,
} from 'Responsive';
import LinkWithHashChange from 'LinkWithHashChange';
import SidebarGuideInfoSectionTitle from './SidebarGuideInfoSectionTitle';
import SidebarGuideTab from './SidebarGuideTab';

const sectionContentStyle = {
  marginTop: 24,
};

const listItemContainerStyle = {
  listStyle: 'none',
  paddingLeft: 51,
};

const listItemStyle = {
  marginBottom: 11,
  paddingBottom: 13,
};

const arrowRightStyle = {
  borderBottom: '12px solid transparent',
  borderLeft: '12px solid #66748A',
  borderTop: '12px solid transparent',
  height: 0,
  left: 0,
  position: 'absolute',
  width: 0,
};

export default class SidebarGuideInfoSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      manuallySet: false,
      open: false,
    };

    this.onClick = this.onClick.bind(this);
    this.isOpen = this.isOpen.bind(this);
    this.renderSection = this.renderSection.bind(this);
    this.renderSectionItems = this.renderSectionItems.bind(this);
  }

  onClick() {
    this.setState({
      manuallySet: true,
      open: !this.isOpen(),
    });
  }

  isOpen() {
    const manuallyOpen = this.state.manuallySet && this.state.open;
    const automaticOpen = (
      !this.state.manuallySet &&
      (this.props.activeSectionIdx === this.props.sectionOffset)
    );
    return (manuallyOpen || automaticOpen);
  }

  renderSectionItems() {
    const {
      activeSectionItemIdx,
      enableSectionOpen,
      offset,
      section,
      toggleProps,
    } = this.props;

    const className = classnames(
      'rank-brain-2-sidebar-guide-section-item-list',
      {
        hidden: !this.isOpen() || !enableSectionOpen,
      },
    );

    return (
      <ul className={className} style={listItemContainerStyle}>
        {
          section.sectionItems.map(
            (sectionItem, idx) => {
              const listItemClassName = classnames(
                'rank-brain-2-sidebar-guide-section-item',
                {
                  active: activeSectionItemIdx === (offset + idx),
                },
              );

              const linkProps = {
                isDynamic: true,
                to: sectionItem.idTarget,
                spy: true,
                offset: -100,
                duration: 500,
              };

              let arrowRight = null;
              if (activeSectionItemIdx === (offset + idx)) {
                arrowRight = (<div className="arrow-right" style={arrowRightStyle} />);
              }

              if (!sectionItem.idTarget && sectionItem.type === 'tab') {
                return <SidebarGuideTab sectionItem={sectionItem} />;
              }

              return (
                <li className={listItemClassName} style={listItemStyle} key={sectionItem.title}>
                  <Desktop>
                    <LinkWithHashChange
                      smooth
                      {...linkProps}
                    >
                      {arrowRight}
                      <span>{sectionItem.title}</span>
                    </LinkWithHashChange>
                  </Desktop>
                  <Tablet>
                    <LinkWithHashChange
                      smooth
                      {...linkProps}
                      onClick={toggleProps.toggleSideBar}
                    >
                      {arrowRight}
                      <span>{sectionItem.title}</span>
                    </LinkWithHashChange>
                  </Tablet>
                  <Mobile>
                    <LinkWithHashChange
                      {...linkProps}
                      onClick={toggleProps.toggleSideBar}
                    >
                      {arrowRight}
                      <span>{sectionItem.title}</span>
                    </LinkWithHashChange>
                  </Mobile>
                </li>
              );
            },
          )
        }
      </ul>
    );
  }

  renderSection() {
    const {
      section,
    } = this.props;
    return (
      <li
        key={section.title}
        className="rank-brain-2-sidebar-guide-section"
      >
        <div style={sectionContentStyle}>
          <SidebarGuideInfoSectionTitle
            {...this.props}
            onClick={this.onClick}
          />

          { this.renderSectionItems() }
        </div>
      </li>
    );
  }

  render() {
    return this.renderSection();
  }
}

SidebarGuideInfoSection.defaultProps = {
  section: {},
  enableSectionOpen: false,
};

SidebarGuideInfoSection.propTypes = {
  enableSectionOpen: PropTypes.bool,
  section: PropTypes.shape({}),
  sectionOffset: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  activeSectionIdx: PropTypes.number.isRequired,
  activeSectionItemIdx: PropTypes.number.isRequired,
  toggleProps: PropTypes.shape({
    toggleSideBar: PropTypes.func,
    includeText: PropTypes.bool,
    hoverImgSrc: PropTypes.string,
    imgSrc: PropTypes.string,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarNavbar/SidebarGuideInfoSection/index.jsx